// FILECONTENT_START src/common/components/Button/Button.tsx
import {
  CircularProgress,
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
} from "@mui/material";
import { useRef } from "react";
import { LongPressOptions, useLongPress } from "./../../modules/helpers";
export interface ButtonProps extends MuiButtonProps {
  title?: string;
  loading?: boolean;
  onLongClick?: () => void;
  onClickInOut?: (isIn: boolean) => void;
  longPressOptions?: LongPressOptions;
}
export default function Button({
  title,
  loading,
  startIcon,
  disabled,
  onClick,
  children,
  onLongClick,
  onClickInOut,
  longPressOptions,
  ...buttonProps
}: ButtonProps) {
  const justClicked = useRef(false);

  const longPressEvent = useLongPress(
    () => {
      //LongPress

      onLongClick && onLongClick();
    },
    (evt: any) => {
      //Press

      if (!justClicked.current) {
        justClicked.current = true;
        setTimeout(() => {
          justClicked.current = false;
        }, 400);
        onClick && onClick(evt);
      }
    },
    inOut => {
      //Cancel LongPress

      onClickInOut && onClickInOut(inOut);
    },
    longPressOptions
  );

  return (
    <MuiButton
      startIcon={loading ? <CircularProgress size={20} /> : startIcon}
      disabled={loading || disabled}
      /*onClick={evt => {
        if (!justClicked.current) {
          justClicked.current = true;
          setTimeout(() => {
            justClicked.current = false;
          }, 400);
          onClick && onClick(evt);
        }
      }}*/
      {...longPressEvent}
      variant="contained"
      color="primary"
      {...buttonProps}
    >
      <span
      /*style={{
          marginBottom: startIcon || buttonProps.endIcon ? "-3px" : undefined,
        }}*/
      >
        {children || title}
      </span>
    </MuiButton>
  );
}

// FILECONTENT_END src/common/components/Button/Button.tsx